import { useEffect, useRef } from 'react';

export const useDidMountEffect = (callback: () => void, deps: any[]) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      callback();
    } else {
      didMount.current = true;
    }
    // eslint-disable-next-line
  }, deps);
};
